import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";
import Cookies from "js-cookie";

import { LoginButton } from "../components/LoginButton";
import { Loader } from "../components/UI/Loader";
import { request } from "../utils/axios-utils";
import { USER_AUTH, USER_EMAIL } from "../utils/constants";
import { Button } from "@mui/material";
import { AxiosResponse } from "axios";

const Logo = require("../assets/FullLogo.png");

type LoginResponse = {
  msg: string;
  user: {
    date_login: string;
    email: string;
    first_name: string;
    id: number;
    last_name: string;
    login: string;
    phone: string;
  };
};

const LoginPage = () => {
  const navigate = useNavigate();

  const token = /access_token=([^&]+)/.exec(window.location.hash)?.[1];

  useEffect(() => {
    if (Cookies.get(USER_AUTH)) {
      navigate("/account");
    }
  });

  useEffect(() => {
    if (token) {
      request({ url: "api/v2/login/yandex", method: "post", data: { token } })
        .then((res: AxiosResponse<LoginResponse>) => {
          const { user }: LoginResponse = res.data;
          Cookies.set(USER_AUTH, String(user.id));
          Cookies.set(USER_EMAIL, user.email);
          navigate("/account");
        })
        .catch((err) => {
          console.error(err.message);
        });
    }
  }, [navigate, token]);

  if (token) {
    return <Loader />;
  }

  return (
    <Container>
      <div className="box">
        <LogoImg src={Logo} alt="logo" />
        <h1>Войти в личный кабинет</h1>
        <LoginButton />
        <a href="https://api.scaptcha.com/storybook/">
          <SButton variant="outlined">Демо без регистрации</SButton>
        </a>
      </div>
    </Container>
  );
};

export default LoginPage;

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;

  .box {
    max-width: 24rem;
    width: 100%;
    display: flex;
    margin-top: 150px;
    justify-content: center;
    padding: 2rem 2.5rem 3rem 2.5rem;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    border: none;
    outline: none;
    border-radius: 0.25rem;
    color: #121212;
    background: #ffffff;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -2px rgb(0 0 0 / 5%);

    @media screen and (max-width: 767px) {
      max-width: 18rem;
    }

    & h1 {
      font-size: 24px;
      text-align: center;
      white-space: nowrap;

      @media screen and (max-width: 767px) {
        font-size: 18px;
      }
    }
  }
`;

const LogoImg = styled.img`
  width: 256px;

  @media screen and (max-width: 767px) {
    width: 200px;
  }
`;

const SButton = styled(Button)`
  max-width: 260px;
  max-height: 50px;
  width: 260px;
  height: 50px;
  border-radius: 10px !important;
`;
